<template>
  <div class="order-costs-graph" v-if="dataAvailable">
    <e-chart
      :option="orderCostsGraphOptions"
      :autoresize="true"
      ref="chart"
      @legendselectchanged="updateTotalCosts($event)"
    ></e-chart>
  </div>
  <div v-else>
    <p>{{ $t('reporting.industry.noData') }}</p>
  </div>
</template>

<script>
import stringUtils from '@/components/mixins/stringUtils'

export default {
  name: 'OrderCostsGraph',
  props: {
    orderCostsData: {
      type: Object,
      required: true,
    },
  },
  mixins: [stringUtils],
  data() {
    return {
      dataAvailable: false,
      totalCosts: 0,
    }
  },
  computed: {
    orderCostsGraphOptions: function () {
      return {
        title: {
          top: '27%',
          left: 'center',
          text: `${this.euro(this.totalCosts)}`,
          textStyle: {
            fontSize: 12,
          },
        },
        legend: {
          bottom: '5%',
          left: 'center',
          icon: 'circle',
          textStyle: {
            fontWeight: 'lighter',
          },
        },
        series: [
          {
            name: 'Order Costs',
            type: 'pie',
            center: ['50%', '30%'],
            radius: ['30%', '40%'],
            label: {
              show: true,
              formatter: input => {
                const data = input.data
                return `${this.euro(data.value)}\n(${data.total_count})`
              },
            },
            labelLine: {
              show: true,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
            data: this.orderCostsData.monthly_costs_by_order_type,
          },
        ],
      }
    },
  },
  watch: {
    orderCostsData() {
      this.dataAvailable = this.orderCostsData.monthly_costs_by_order_type.some(data => data.value > 0)
      this.updateTotalCosts(null)
    },
  },
  methods: {
    updateTotalCosts: function (event) {
      let costsData = this.orderCostsData.monthly_costs_by_order_type
      if (event) {
        const selectedTypes = event.selected
        costsData = costsData.filter(data => selectedTypes[data.name])
      }

      this.totalCosts = costsData.reduce((acc, cur) => acc + cur.value, 0)
    },
  },
}
</script>

<style lang="scss" scoped>
.order-costs-graph {
  height: 300px;
}
</style>
